import { LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';

const FsaResearch = (): JSX.Element => {
  const t = useTranslations();

  return (
    <LayoutGrid className="gap-y-10 bg-sandstone-100 py-20 lg:py-24">
      <div className="col-main lg:col-end-20">
        <TypographyV3 variant="h4" Element="h2" color="unset" className="">
          {t('heart_rate_monitoring_research_title')}
        </TypographyV3>
      </div>

      <div className="col-main lg:col-start-9 lg:col-end-16">
        <Image
          localizedAlt="heart_rate_monitoring_uc_san_diego_alt"
          className="mb-4 h-16 w-auto"
          loading="lazy"
          width={330}
          height={50}
          src="meet-the-community/logo-UCSD@2x"
          format="png"
        />
        <TypographyV3>
          {t('heart_rate_monitoring_uc_san_diego_description')}
        </TypographyV3>
      </div>

      <div className="col-main lg:col-start-17">
        <Image
          localizedAlt="heart_rate_monitoring_virginia_alt"
          className="mb-4 h-16 w-auto"
          loading="lazy"
          width={330}
          height={50}
          src="meet-the-community/logo-WVU@2x"
          format="png"
        />
        <TypographyV3>
          {t('heart_rate_monitoring_virginia_description')}
        </TypographyV3>
      </div>
    </LayoutGrid>
  );
};

export default FsaResearch;
